import { Container, Flex, Link, Text } from "@chakra-ui/react";
import { Input, Visible } from "components";
import { useState } from "react";

const Preferences = () => {
    const [editGlobalPreferences, setEditGlobalPreferences] = useState(false);
    const [editAirlinePreferences, setEditAirlinePreferences] = useState(false);
    const [editAirportPreferences, setEditAirportPreferences] = useState(false);
    const [editTrainPreferences, setEditTrainPreferences] = useState(false);
    const [editHotelPreferences, setEditHotelPreferences] = useState(false);

    const getColor = () => (editGlobalPreferences ||editAirlinePreferences||editAirportPreferences||editTrainPreferences||editHotelPreferences) && '#A3A3A3'
    
    const onEditGlobalPreferences = () => {
       if (editAirlinePreferences || editAirportPreferences || editHotelPreferences || editTrainPreferences) {
        return;
       } 
        setEditGlobalPreferences(!editGlobalPreferences);
    };

    const onEditAirlinePreferences = () => {
        if (editGlobalPreferences || editAirportPreferences || editHotelPreferences || editTrainPreferences) {
         return;
        } 
         setEditAirlinePreferences(!editAirlinePreferences);
     };
 
     const onEditAirportPreferences = () => {
        if (editGlobalPreferences || editAirlinePreferences || editHotelPreferences || editTrainPreferences) {
         return;
        } 
         setEditAirportPreferences(!editAirportPreferences);
     };
 
     const onEditTrainPreferences = () => {
        if (editGlobalPreferences || editAirportPreferences || editHotelPreferences || editAirlinePreferences) {
         return;
        } 
         setEditTrainPreferences(!editTrainPreferences);
     };
 
     const onEditHotelPreferences = () => {
        if (editGlobalPreferences || editAirportPreferences || editAirlinePreferences || editTrainPreferences) {
         return;
        } 
         setEditHotelPreferences(!editHotelPreferences);
     };
 
    return (
      <Container>
        <Flex justifyContent='space-between'  marginBottom={5} align='center'>
            <Text fontWeight={700} color={!editGlobalPreferences ? getColor() || '' : ''} fontSize='26px'>Global Preferences</Text>
            <Link fontWeight={600} color={!editGlobalPreferences ? getColor() || '' : ''} fontSize='16px' onClick={onEditGlobalPreferences}>{editGlobalPreferences ? 'Cancel':'Edit'}</Link>
        </Flex>
        <Input disabled={!editGlobalPreferences} marginBottom={4} placeholder="Language Preference" variant="filled" padding={7} />
        <Input disabled={!editGlobalPreferences}  marginBottom={4} placeholder="Currency Preference" variant="filled" padding={7}/>
        <Flex maxWidth='300px'>
            <Input  disabled={!editGlobalPreferences} marginBottom={4} placeholder="Timezone" variant="filled" padding={7} />
        </Flex>
        <Visible when={editGlobalPreferences}>
            <Flex justifyContent='end'>
                <Link alignSelf='end' fontWeight={600} fontSize='16px' color="#3498FE" onClick={() => setEditGlobalPreferences(!editGlobalPreferences)}>Save</Link>  
            </Flex>
        </Visible>
        <Flex justifyContent='space-between'  marginBottom={5} align='center'>
            <Text fontWeight={700} color={!editAirlinePreferences ? getColor() || '' : ''} fontSize='26px'>Airline Preference</Text>
            <Link fontWeight={600} color={!editAirlinePreferences ? getColor() || '' : ''} fontSize='16px' onClick={onEditAirlinePreferences}>{editAirlinePreferences ? 'Cancel':'Edit'}</Link>
        </Flex>
        <Input disabled={!editAirlinePreferences} marginBottom={4} placeholder="Iberia" variant="filled" padding={7} />
        <Visible when={editAirlinePreferences}>
            <Flex justifyContent='end'>
                <Link alignSelf='end' fontWeight={600} fontSize='16px' color="#3498FE" onClick={() => setEditAirlinePreferences(!editAirlinePreferences)}>Save</Link>  
            </Flex>
        </Visible>
        <Flex justifyContent='space-between'  marginBottom={5} align='center'>
            <Text fontWeight={700} color={!editAirportPreferences ? getColor() || '' : ''} fontSize='26px'>Airport Preference</Text>
            <Link fontWeight={600} color={!editAirportPreferences ? getColor() || '' : ''}fontSize='16px' onClick={onEditAirportPreferences}>{editAirportPreferences ? 'Cancel':'Edit'}</Link>
        </Flex>
        <Input disabled={!editAirportPreferences} marginBottom={4} placeholder="Home Airport" variant="filled" padding={7} />
        <Visible when={editAirportPreferences}>
            <Flex justifyContent='end'>
                <Link alignSelf='end' fontWeight={600} fontSize='16px' color="#3498FE" onClick={() => setEditAirportPreferences(!editAirportPreferences)}>Save</Link>  
            </Flex>
        </Visible>
        <Flex justifyContent='space-between' marginBottom={5} align='center'>
            <Text fontWeight={700} color={!editTrainPreferences ? getColor() || '' : ''} fontSize='26px'>Train Preference</Text>
            <Link fontWeight={600} color={!editTrainPreferences ? getColor() || '' : ''} fontSize='16px' onClick={onEditTrainPreferences}>{editTrainPreferences ? 'Cancel':'Edit'}</Link>
        </Flex>
        <Input disabled={!editTrainPreferences} marginBottom={4} placeholder="Prefferred Train" variant="filled" padding={7} />
        <Visible when={editTrainPreferences}>
            <Flex justifyContent='end'>
                <Link alignSelf='end' fontWeight={600} fontSize='16px' color="#3498FE" onClick={() => setEditTrainPreferences(!editTrainPreferences)}>Save</Link>  
            </Flex>
        </Visible>
        <Flex justifyContent='space-between'  marginBottom={5}  align='center'>
            <Text fontWeight={700} color={!editHotelPreferences ? getColor() || '' : ''} fontSize='26px'>Hotel Preference</Text>
            <Link fontWeight={600} color={!editHotelPreferences ? getColor() || '' : ''} fontSize='16px' onClick={onEditHotelPreferences}>{editHotelPreferences ? 'Cancel':'Edit'}</Link>
        </Flex>
        <Input disabled={!editHotelPreferences} marginBottom={4} placeholder="Prefferred Hotel" variant="filled" padding={7} />
        <Visible when={editHotelPreferences}>
            <Flex justifyContent='end'>
                <Link alignSelf='end' fontWeight={600} fontSize='16px' color="#3498FE" onClick={() => setEditHotelPreferences(!editHotelPreferences)}>Save</Link>  
            </Flex>
        </Visible>
      </Container>
    );
  };
  
  export { Preferences };
  